// src/sectors/pilates/reports/staff/overview/utils/overviewFormatters.js
export function n0(v) {
  const n = Number(v);
  return Number.isFinite(n) ? n : 0;
}

export function safeText(v, fallback = '—') {
  const s = (v ?? '').toString().trim();
  return s ? s : fallback;
}

export function fmtTry(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  return `₺${n.toLocaleString('tr-TR')}`;
}

export function fmtDateTR(v) {
  if (!v) return '—';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('tr-TR');
}

export function fmtTimeTR(v) {
  if (!v) return '—';
  const d = new Date(v);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
}

/** "2026-02-15 – 2026-03-15" -> {startISO,endISO} */
export function parsePackagePeriod(period) {
  const s = safeText(period, '');
  const parts = s.split('–').map((x) => x.trim());
  if (parts.length !== 2) return null;
  const startISO = parts[0];
  const endISO = parts[1];
  if (!/^\d{4}-\d{2}-\d{2}$/.test(startISO) || !/^\d{4}-\d{2}-\d{2}$/.test(endISO)) return null;
  return { startISO, endISO };
}

export function isoToDateLocal(iso) {
  if (!iso) return null;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function pct(v) {
  const n = Number(v);
  if (!Number.isFinite(n)) return '—';
  return `${Math.round(n)}%`;
}
